/* eslint-disable react/prop-types */
import React, { Component } from "react";
import { Form, Button, Segment, Grid, Divider } from "semantic-ui-react";
import { withRouter } from "react-router-dom";
import Constants from "utilities/Constants";
import Strings from "utilities/StringSelector";
import Utils from "utilities/Utils";
import sha256 from "js-sha256";

const UtilsInstance = new Utils();

class ChangeLogin extends Component {

  handleUsernameSubmit = () => {
    let username = document.getElementById("username").value;

    if (username.length >= 1) {
      let data = JSON.stringify({
        login: username
      });

      fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "alter_login_POST", {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        },
        body: data
      })
        .then(UtilsInstance.checkStatus)
        .then(() => {
          alert(Strings.CHANGE_USERNAME_SUCCESS);
          sessionStorage.removeItem("auth");
          this.props.history.push({ pathname: "/login-handler" });
        })
        .catch((error) => {
          if (undefined !== error) {
            alert(Strings.CHANGE_USERNAME_FAILURE + error);
          }
        });
    }
    else {
      alert(Strings.USERNAME_TOO_SHORT);
    }
  }

  handlePasswordSubmit = () => {
    let newPass = document.getElementById("newPassword").value;
    let repeatNewPass = document.getElementById("newRepeatPassword").value;

    if (newPass !== repeatNewPass) {
      alert(Strings.PASSWORD_MISSMATCH);
    }
    else {
      let data = JSON.stringify({
        new: sha256(newPass)
      });

      fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "alter_password_POST", {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        },
        body: data
      })
        .then(UtilsInstance.checkStatus)
        .then(() => {
          alert(Strings.CHANGE_PASSWORD_SUCCESS);
          sessionStorage.removeItem("auth");
          this.props.history.push({ pathname: "/login-handler" });
        })
        .catch((error) => {
          if (undefined !== error) {
            alert(Strings.CHANGE_PASSWORD_FAILURE + error);
          }
        });
    }
  }

  retrieveData = () => {
    fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "username", { mode: "cors" })
      .then(res => res.json())
      .then(data => document.getElementById("username").value = data.login);
  }

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    this.retrieveData();
  }

  render() {
    return (
      <Grid columns={2} doubling>
        <Grid.Column>
          <Segment style={centerAlignStyle}>
            <Divider horizontal>{Strings.ALTER_USERNAME}</Divider>
            <Form onSubmit={this.handleUsernameSubmit}>
              <Form.Input
                id="username"
                placeholder={Strings.USER}
                name="username"
                type="text"
                autoComplete="off" />
              <Button color="teal" type="submit" >{Strings.ALTER}</Button>
            </Form>
          </Segment>
        </Grid.Column>

        <Grid.Column>
          <Segment style={centerAlignStyle}>
            <Divider horizontal>{Strings.ALTER_PASSWORD}</Divider>
            <Form onSubmit={this.handlePasswordSubmit}>
              <Form.Input
                id="newPassword"
                placeholder={Strings.NEW_PASSWORD}
                name="newPassword"
                type="password"
                autoComplete="off" />
              <Form.Input
                id="newRepeatPassword"
                placeholder={Strings.REPEAT_PASSWORD}
                name="newRepeatPassword"
                type="password"
                autoComplete="off" />
              <Button color="teal" type="submit" >{Strings.ALTER}</Button>
            </Form>
          </Segment>
        </Grid.Column>
      </Grid>
    );
  }
}

const centerAlignStyle = {
  textAlign: "center"
};

export default withRouter(ChangeLogin);
